import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FixedKeyboardEvent, KEY_CODES, SearchControl, useScopedSelector } from 'ia-react-core';
import { StyledP, StyledTile, StyledSearchTileCol, StyledForm } from './SearchDocumentsTile.styles';
import redirectToSearchPage from '../../utils/redirectToSearchPage';

export interface SearchDocumentsTileProps { }

const SearchDocumentsTile: FC<SearchDocumentsTileProps> = () => {
  const { t } = useTranslation('SearchDocumentsTile');
  const inputValue: string = useScopedSelector('/App.HomePage.SearchDocumentsValues.searchDocumentsInput');
  const handleKeyDown = useCallback((event: FixedKeyboardEvent) => {
    if (event?.keyCode === KEY_CODES.ENTER) {
      redirectToSearchPage(inputValue);
    }
  }, [inputValue]);
  return (
    <StyledSearchTileCol>
      <StyledTile data-testid="searchDocumentsBox" title={t('searchDocumentsTile.title')} isDivided={false}>
        <StyledP>
          {t('searchDocumentsTile.text')}
        </StyledP>
        <StyledForm name="SearchDocuments">
          <SearchControl onKeyDown={handleKeyDown} name="searchDocumentsInput" placeholder={t('searchDocumentsTile.search')} onSearch={() => redirectToSearchPage(inputValue)} />
        </StyledForm>
      </StyledTile>
    </StyledSearchTileCol>
  );
};
export default SearchDocumentsTile;
